/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `The resources most loved by the community`
};

const fr_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `Les coups de cœur de notre communauté`
};

const de_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `Die von der Community am meisten geliebten Ressourcen`
};

const es_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `Los recursos más queridos por la comunidad`
};

const it_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `Le risorse più amate dalla comunità`
};

const ar_home_most_liked_collections_description35 = /** @type {(inputs: {}) => string} */ () => {
	return `الموارد الأكثر تفضيلاً من قبل المجتمع`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_most_liked_collections_description35 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_most_liked_collections_description35(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_most_liked_collections_description35", locale)
	if (locale === "en") return en_home_most_liked_collections_description35(inputs)
	if (locale === "fr") return fr_home_most_liked_collections_description35(inputs)
	if (locale === "de") return de_home_most_liked_collections_description35(inputs)
	if (locale === "es") return es_home_most_liked_collections_description35(inputs)
	if (locale === "it") return it_home_most_liked_collections_description35(inputs)
	return ar_home_most_liked_collections_description35(inputs)
};
export { home_most_liked_collections_description35 as "HOME_MOST_LIKED_COLLECTIONS_DESCRIPTION" }